export const MUTATION_KEYS = {
  GET_FILE: ['sgr', 'file'],
  GET_PAYMENTS: ['sgr', 'payments'],
  GET_INVOICING: ['sgr', 'invoicing'],
  CREATE: ['sgr', 'create'],
  EMIT_INVOICE: ['sgr', 'emit', 'invoice'],
  UPDATE: ['sgr', 'update'],
  START_CLAIM: ['sgr', 'start', 'claim'],
  MARK_AS_LOST: ['sgr', 'mark', 'lost'],
  REVERSE_MARK_AS_LOST: ['sgr', 'reverse', 'lost'],
  SGR_CANCEL: ['sgr', 'cancel'],
  UPDATE_OPPORTUNITY_STATUS: ['sgr', 'opportunity', 'status'],
} as const;

export const BASE_ROUTE = 'internal/sgrWarrantyRequest';
